import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
  })
  export class ResetSenhaService {

    apiUrl: string = `${environment.auth}/securiy/reset`;

    vazio: any[] = [];
  
    constructor(private http: HttpClient) { }
  
      httpOptions = {
          headers: {
              'Content-Type': 'application/json',
          }
      }
  
    requisisarNovaSenha(usuario: string): Observable<any> {
        return this.http.post(`${this.apiUrl}`, usuario, { headers: this.httpOptions.headers });
      }
  
  }